// src/encounter/structured-note/note-detail-text.tsx
//
// PROD-2947 · frame v2 ONLY · the 6 Oct contract, K6 in the value position of ANOTHER line (G7, one place per fact).
// When a template carries two items for one fact under the same label — the live Pain template's "Location" is a
// text item AND a choice item — the note draws ONE "Location" line: the choice as its pick list, and the text as this
// detail beside it. Empty: a quiet "Add detail". Written: the text as plain prose with a quiet "Edit". Editing: one
// inline field, opened focused; left empty it closes and nothing is written. Read-only (rule 38): the text, or nothing.
// The text item keeps its own linkId and answer; only where it is drawn changes.
import { useState } from 'react';
import { Button, TextField } from '@scripsteam/scrips-signal-ds';
import { AddEntryButton } from '../add-entry';

export interface NoteDetailTextProps {
  /** The fact's label ("Location"), for the actions' names. */
  label: string;
  value: string;
  onChange?: (text: string) => void;
  readOnly?: boolean;
}

export function NoteDetailText({ label, value, onChange, readOnly = false }: NoteDetailTextProps) {
  const [editing, setEditing] = useState(false);
  const writable = !readOnly && !!onChange;
  const written = value.trim() !== '';
  if (editing && writable) {
    return (
      <span className="flex w-full" data-note-detail="editing">
        <TextField
          autoFocus
          value={value}
          aria-label={`${label} detail`}
          onChange={(e) => onChange?.(e.target.value)}
          onBlur={() => setEditing(false)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === 'Escape') setEditing(false);
          }}
        />
      </span>
    );
  }
  if (!written && !writable) return null;
  return (
    <span className="flex flex-wrap items-baseline gap-2" data-note-detail={written ? 'written' : 'empty'}>
      {written && <span className="whitespace-pre-wrap break-words text-text-primary">{value}</span>}
      {writable && (
        written ? (
          <Button variant="tertiary" size="sm" aria-label={`Edit ${label} detail`} onClick={() => setEditing(true)}>
            Edit
          </Button>
        ) : (
          <AddEntryButton aria-label={`Add ${label} detail`} onClick={() => setEditing(true)}>
            Add detail
          </AddEntryButton>
        )
      )}
    </span>
  );
}
